// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.googlemaps.RentalManagerGoogleMapsWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { GoogleMapsSignedUrlResponseDto, GoogleMapsSignUrlRequestDto } from '../..';

export const RentalManagerGoogleMapsWebApiHandler_addSignatureAndKeyToUrl_Path =
  '/api/web/v1/users/googleMaps/addSignatureAndKeyToUrl';

/**
 * Add GoogleMap signature and key to URL
 */
export const RentalManagerGoogleMapsWebApiHandler_addSignatureAndKeyToUrl = (
  postData: GoogleMapsSignUrlRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, GoogleMapsSignUrlRequestDto, GoogleMapsSignedUrlResponseDto>(
    {
      endpoint: RentalManagerGoogleMapsWebApiHandler_addSignatureAndKeyToUrl_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};
